Vue.component('importcol', {
    props: ['user','header'],
    data: function () {
        return {
            count: 0
        }
    },
    methods: {
        onClickCreate: function (evt) {
            window.open('/objects/create', '_self');
        }
    },
    //template: '<div>{{ header }}</div>',
    mounted () {
        console.log(this.header);
    }
});
